<template>
  <transition name="fade">
    <div class="modal creditCardModal" v-if="show">
      <div class="modal__backdrop" @click="closeModal()" />

      <div class="modal__dialog" :style="containerStyle">
        <div class="modal__header" :style="headerStyleAttr">
          <span class="title">Credit Cards</span>
          <span class="subtitle">Select the credit card you would like to use</span>
          <button type="button" title="Close (Esc)" class="modal__close" @click="closeModal()">×</button>
        </div>

        <div class="modal__body" :style="bodyStyleAttr">
          <img src="@/assets/Loading_icon.gif" class="loader-icon" width="250" height="150" alt="Loading..." style="display: none; margin: auto;"/>
          <div class="credit-card-container">
            <ul>
                <li :data-token="cc.token" v-for="cc in creditCards" :key="cc.id" @click="selectItem($event)">
                    <i :class="'fa ' + getIcon(cc.brand) + ' fa-3x'"></i>
                    <div>
                        <p class="card-brand">{{cc.brand}}</p>
                        <p class="card-number">{{cc.account}}</p>
                    </div>
                </li>
                <li class="selected" @click="selectItem($event)">
                    <i class="fa fa-plus-circle fa-3x"></i><p class="add">Add New Card</p>
                </li>
            </ul>
          </div>
        </div>

        <div class="modal__footer" style="padding:0px;">
          <div class="col-md-3 col-sm-12 col-xs-12 text-right pull-right">
            <button type="submit" class="btn btn-primary btn-block" @click="selectCreditCard()">OK</button>
          </div>
          <div class="col-md-3 col-sm-12 col-xs-12 text-right pull-right">
            <button type="reset" class="btn btn-default btn-block modal-dismiss" @click="closeModal()">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { view } from "./Checkout.vue.js";

export default {
  name: "CreditCardsModal",
  mixins: [view],
  props: {
      containerStyle: String,
      headerStyle: String,
      bodyStyle: String,
      footerStyle: String,
  },
  data() {
    return {
      show: false,
      containerStyleAttr: !this.isStringNullOrEmpty(this.containerStyle) ? this.containerStyle : "",
      headerStyleAttr: !this.isStringNullOrEmpty(this.headerStyle) ? this.headerStyle : "",
      bodyStyleAttr: !this.isStringNullOrEmpty(this.bodyStyle) ? this.bodyStyle : "",
      footerStyleAttr: !this.isStringNullOrEmpty(this.footerStyle) ? this.footerStyle : "",

      creditCards: []
    };
  },
  methods: {
    closeModal() {
      this.show = false;
    },
    openModal() {
      this.show = true;
    },
    showLoader(){
      document.querySelectorAll('.creditCardModal .modal__dialog button').forEach((item) => {
          item.setAttribute("style", "display: none !important");
      });
      document.querySelector('.creditCardModal .credit-card-container').style.display = "none";
      document.querySelector('.creditCardModal .modal__body .loader-icon').style.display="block";
    },
    populate(data) {
      this.creditCards = data;
    },
    selectItem(event){
      document.querySelectorAll('.credit-card-container ul li').forEach((item) => {
          item.classList.remove('selected');
      });
      event.target.classList.add('selected');
    },
    getIcon: function(brand){
      var cards = ["diners-club", "jcb", "stripe", "amex", "discover", "mastercard", "visa" ];
      var icon = "fa-credit-card";
      if(cards.includes(brand.toLowerCase()))
        icon = "fa-cc-" + brand.toLowerCase();
      
      return icon;
    }
  },
  mounted() {
    
  }
};
</script>
<style scoped>
.modal {
  display: block;
  overflow-x: hidden;
  overflow-y: auto;
  position: fixed;
  top: 20vh;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
}
.modal__backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1;
}
.modal__dialog {
  position: relative;
  width: 100%;
  max-width: 1200px;
  background-color: #ffffff;
  border-radius: 5px;
  margin: 50px auto auto auto;
  display: flex;
  flex-direction: column;
  z-index: 2;
  max-height: 90vh;
}
.modal__header {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  height: auto;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px 20px 10px;
  background-size: contain;
  background-color: #0099e6 !important;
  background-repeat: no-repeat;
  color: white !important;
}
.modal__header .title{
  display: block;
  font-size: 20px;
  font-weight: 400;
  line-height: 20px;
}
.modal__header .subtitle{
  display: block;
  font-weight: 500;
  font-size: 12px !important;
  line-height: 1.2em;
  margin: 7px 0 0;
}
.modal__header .modal__close {
  width: 44px;
  height: 44px;
  line-height: 44px;
  position: absolute;
  right: 0;
  top: 0;
  text-align: center;
  opacity: 0.65;
  background: transparent;
  color: white !important;
  border: none;
  font-family: "Open Sans", Arial, sans-serif;
  font-weight: 600;
  font-size: 22px;
}
.modal__body {
  padding: 15px !important;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.modal__body ul {
  margin: 0 !important;
}
.modal__footer {
  padding: 10px 0px !important;
  border-top: 1px #ddd solid;
}
.modal__footer .btn {
  border-color: #ccc !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@media screen and (max-width: 992px) {
  .modal__dialog {
    width: 90vw;
  }
}
@media screen and (max-width: 500px){
  .modal__dialog {
      height: auto !important;
      position: absolute; 
      top: 30%;
      left: 50%; 
      transform: translate(-50%, -50%); 
  }
}

  .credit-card-container ul {
    list-style: none;
    padding: 0px;
  }
    .credit-card-container ul li {
      line-height: 30px;
      height: 55px;
      border: 1px solid #d1d1d1;
      border-radius: 5px;
      margin-bottom: 3px;
      padding: 5px;
      background-image: linear-gradient( to bottom, rgb(255 253 253), rgb(211 208 208) );
      display: flex;
    }
      .credit-card-container ul li:hover {
        background: #f5f5f5;
        border: 1px solid #afafaf;
      }
      .credit-card-container ul li.selected {
        background: #68a2d5;
        border: 1px solid #afafaf;
      }
      .credit-card-container ul li i {
        color: #404040 !important;
        width: 56px;
        text-align: center;
      }
      .credit-card-container ul li p {
        margin: 0px;
        margin-left: 15px;
        vertical-align: bottom;
        line-height: 22px;
      }
        .credit-card-container ul li p.card-brand {
          font-weight: 600;
        }
        .credit-card-container ul li p.card-number {
          color: #5e5e5e;
          font-size: 12px;
        }
        .credit-card-container ul li p.add {
          font-weight: 600;
          line-height: 44px;
        }
  .pull-right{
    float: right;
  }
</style>